import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M6 5h4v14H6zm8 0h4v14h-4z"
}), 'PauseTwoTone');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/PauseTwoTone.js
// module id = 5235
// module chunks = 2